// extracted by mini-css-extract-plugin
module.exports = {"menuSubTitle":"AllTitlesSidebar_menuSubTitle__1NEqw","dropDownTitle":"AllTitlesSidebar_dropDownTitle__2MtyX"};